export class CaseTypeCalcModel {
  CaseTypeId: string;
  CaseTypeDescription: string;
}
